<script lang="ts" setup>
import { useElementHover, useMutationObserver } from '@vueuse/core';
import { computed, ref, useTemplateRef } from 'vue';
import { hasSlotContent } from '../../../utils';
const rootRef = useTemplateRef('root');
const isHovered = useElementHover(rootRef, {
  delayLeave: 50,
});
const hasExpandedAction = ref(false);
const actionsVisible = computed(() => isHovered.value || hasExpandedAction.value);
function updateExpandedActionState() {
  hasExpandedAction.value = Boolean(rootRef.value?.querySelector('[aria-expanded="true"]'));
}
useMutationObserver(rootRef, updateExpandedActionState, {
  attributes: true,
  attributeFilter: ['aria-expanded'],
  childList: true,
  subtree: true,
});
</script>

<template>
  <div ref="root" :class="$style.root">
    <slot />
    <div v-show="actionsVisible" v-if="hasSlotContent($slots.actions)" :class="$style.actions">
      <div :class="$style.actionsOuter">
        <div :class="$style.actionsInner">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  position: relative;
}

.actions {
  position: absolute;
  left: 0;
  top: calc(100% - 20px);
  width: 100%;
  z-index: 999;
  height: 0;
  pointer-events: none;
}

.actionsOuter {
  position: sticky;
  left: 0;
  display: inline-flex;
  align-items: center;
  height: 40px;
  padding: 0 24px 0 48px;
  vertical-align: middle;
}

.actionsInner {
  display: inline-flex;
  border-radius: 10px;
  border: 1px solid var(--ui2-stroke-secondary, #e4e5e8);
  background: #fff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.08);
  pointer-events: auto;
}
</style>
